import * as Sentry from '@sentry/react'
import { env } from '../config/env'

export class HttpError extends Error {
  readonly name = 'HttpError'
  readonly status: number
  readonly url: string
  readonly body: unknown

  constructor(opts: { status: number; url: string; body: unknown }) {
    super(`HTTP ${opts.status}`)
    this.status = opts.status
    this.url = opts.url
    this.body = opts.body
  }
}

export async function requestJson<T>(
  path: string,
  init: RequestInit & { signal?: AbortSignal } = {},
): Promise<T> {
  const baseUrl = env.VITE_API_BASE_URL
  const url = baseUrl ? new URL(path, baseUrl).toString() : path

  const res = await fetch(url, {
    ...init,
    credentials: init.credentials ?? 'include',
    headers: {
      Accept: 'application/json',
      ...(init.body ? { 'Content-Type': 'application/json' } : null),
      ...(init.headers ?? {}),
    },
  })

  const contentType = res.headers.get('content-type') ?? ''
  const isJson = contentType.includes('application/json')
  const body = isJson ? await res.json().catch(() => null) : await res.text()

  if (!res.ok) {
    const httpError = new HttpError({ status: res.status, url, body })
    if (res.status >= 500) {
      Sentry.captureException(httpError)
    }
    throw httpError
  }

  return body as T
}
